function Contact() {
    return (
        <section className="screen screen_contact">
            <div className="contact-col contact-col_top">
                <div className="contact-col__avatar-container">
                    <img className="contact-col__avatar" src="https://avatars.githubusercontent.com/u/29174256" alt="Frants" />
                </div>
                <div className="contact-col__info-container">
                    <h2 className="contact-col__name">
                        Frants Mitskun
                    </h2>
                    <p className="contact-col__position">
                        Frontend Developer<br />
                    </p>
                    <p className="contact-col__location">
                        Minsk, Belarus
                    </p>
                    <p className="contact-col__interests">
                        Intersted in creative coding, interactivity, motion design, 3D, code efficiency, clean interfaces, user experience, data visualisations
                    </p>
                </div>
            </div>

            <div className="contact-col">
                <p className="contact-col__title">
                    tech/tools
                </p>
                <ul>
                    <li>
                        JS/TS
                    </li>
                    <li>
                        Sass, Less, Pug
                    </li>
                    <li>
                        Vue/Vuex, React/Redux
                    </li>
                    <li>
                        Three.js, (A-Frame, Zappar)
                    </li>
                    <li>
                        Tween.js, GSAP
                    </li>
                    <li>
                        English: A2-B1
                    </li>
                    <li>
                        Russian: Native
                    </li>
                </ul>
            </div>

            <div className="contact-col">
                <p className="contact-col__title">
                    socials
                </p>
                <ul>
                    <li>
                        <a href="//www.linkedin.com/in/frantsm" target="_blank" rel="noreferrer">LinkedIn</a>
                    </li>
                    <li>
                        <a href="//github.com/frantsmn" target="_blank" rel="noreferrer">GitHub</a>
                    </li>
                    <li>
                        <a href="//t.me/frantsm" target="_blank" rel="noreferrer">Telegram</a>
                    </li>
                    <li>
                        <a href="//instagram.com/frantsmn" target="_blank" rel="noreferrer">Instagram</a>
                    </li>
                </ul>
            </div>

        </section>
    )
}

export default Contact;
